// import loadingGif from '../assets/loading.gif';
import loadingGif from '../private_assets/gifs/loading.gif'

const Loader = () => {
    return (
      <div style={styles.container}>
        <img src={loadingGif} alt="Loading..." style={styles.image} />
      </div>
    );
  };
  
  const styles = {
    container: {
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      // backgroundColor: '#77BEF0'
    },
    image: {
      width: '380px',
      height: '380px',
      borderRadius: '25px'
    }
  };
  
  export default Loader;
  